import { useQuery } from '@tanstack/react-query';
import { DropOff, DropOffOpeningTime, IDropOff, IPlace, Place, PointType } from '@packlink/packlink-sdk';
import Packlink from '@sdk';
import { IDropOffPoint, IDropOffPointOpeningTimes } from '@packlink/cartography';

export const GET_DROPOFF_POINTS_KEY = 'getDropOffPoints';
export function useAllDropoffPoints(isMapSelected: boolean, from: Place<IPlace>, serviceId: string) {
    const { isLoading, data } = useQuery<DropOff<IDropOff>[]>({
        queryKey: [GET_DROPOFF_POINTS_KEY, from.city, from.alpha2Code, serviceId, from.zipCode],
        queryFn: () =>
            Packlink.v1.dropOffs
                .all({
                    city: from.city,
                    code: from.alpha2Code,
                    serviceId: serviceId,
                    zip: from.zipCode,
                    pointsType: PointType.DROP_OFF,
                })
                .then((result) => result),
        enabled: isMapSelected,
    });

    const mapDropoffPoints = (dropOffPoints: DropOff[] = []): IDropOffPoint[] => {
        return dropOffPoints.reduce((acc: IDropOffPoint[], dropOff: DropOff): IDropOffPoint[] => {
            dropOff.sortOpeningTimes();
            const dropOffPoint = {
                ...dropOff.toJSON(),
                id: dropOff.id?.toString(),
                openingTimes: dropOff.openingTimes?.map(
                    (openingTime: DropOffOpeningTime): IDropOffPointOpeningTimes => ({
                        day: 'drop-off.address.weekday.' + openingTime.day,
                        time: openingTime.time as IDropOffPointOpeningTimes['time'],
                    }),
                ),
                zip: dropOff.zipCode,
            } as IDropOffPoint;

            acc.push(dropOffPoint);
            return acc;
        }, []);
    };

    return {
        dropoffPoints: mapDropoffPoints(data),
        isLoading,
    };
}
